module.exports = "/_next/static/images/search_bg_31-48184bc3ffe9a78497e0280fb2837f6c.jpg";